import { FC, useCallback } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../../store/hooks";
import { resourceExplorerDataPointSelector } from "../../../../../../../../../store/resource-explorer/selectors/current-resource-explorer/data/resourceExplorerDataPointSelector";
import { DateDataPoint } from "../../../../../../../../../services/cloudchipr.api";
import {
  setResourceExplorerDataPoint,
  setResourceExplorerSearch,
} from "../../../../../../../../../store/resource-explorer/resourceExplorerSlice";
import { getResourceExplorerDataThunk } from "../../../../../../../../../store/resource-explorer/thunks/widgets/getResourceExplorerDataThunk";
import { resourceExplorerPathLastItemFiltersSelector } from "../../../../../../../../../store/resource-explorer/selectors/current-resource-explorer/path/resourceExplorerPathLastItemFiltersSelector";

export const DataPointSelector: FC = () => {
  const dispatch = useAppDispatch();

  const dataPoint = useAppSelector(resourceExplorerDataPointSelector);
  const pathLastItemFilters = useAppSelector(
    resourceExplorerPathLastItemFiltersSelector,
  );

  const changeHandler = useCallback(
    (event: SelectChangeEvent) => {
      dispatch(
        setResourceExplorerDataPoint(event.target.value as DateDataPoint),
      );
      dispatch(
        getResourceExplorerDataThunk({ filtersFromPath: pathLastItemFilters }),
      );
      dispatch(setResourceExplorerSearch(""));
    },
    [dispatch, pathLastItemFilters],
  );

  if (!dataPoint) {
    return null;
  }

  return (
    <FormControl size="xsmall" fullWidth sx={{ width: 110 }}>
      <Select
        value={dataPoint}
        onChange={changeHandler}
        name="data_point"
        sx={{
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "grey.300" },
        }}
      >
        <MenuItem value="daily">
          <Typography variant="caption">Daily</Typography>
        </MenuItem>
        <MenuItem value="weekly">
          <Typography variant="caption">Weekly</Typography>
        </MenuItem>
        <MenuItem value="monthly">
          <Typography variant="caption">Monthly</Typography>
        </MenuItem>
      </Select>
    </FormControl>
  );
};
